const routes = [
  {
    path: '/monitor/incidences/:startDate?/:endDate?',
    props: true,
    component: () => import('@/views/monitor/incidence/Incidences.vue')
  }
]

export default routes
